import { apiInstance } from '../client';

export type PostBuyPropertyRequestFields = {
  full_name: string;
  email: string;
  phone: string;
};

export async function postBuyPropertyRequest(
  fields: PostBuyPropertyRequestFields
): Promise<void> {
  await apiInstance.post('/v2/newsletter/buy_property_request', fields);
}
